import { Box, Button, Icon, Menu, MenuButton, MenuList } from '@chakra-ui/react'
import { SystemVersion } from 'components/atoms'
import React from 'react'
import { CircleCustom } from './styles'

export const Help: React.FC = () => {
    return (
        <Menu data-testid="help">
            <MenuButton
                data-testid="help-box"
                as={Box}
                shadow={{ md: 'md' }}
                gap={2}
                rounded={2}
                cursor="pointer"
            >
                <Button
                    data-testid="help-button"
                    colorScheme="off-white"
                    color="inherit"
                    size="md"
                    gap={2}
                >
                    <Box
                        data-testid="help-avatar"
                        display="flex"
                        justifyContent="center"
                    >
                        <CircleCustom size={5}>
                            <Icon name="question-mark" />
                        </CircleCustom>
                    </Box>
                </Button>
            </MenuButton>
            <MenuList
                data-testid="help-list"
                border={0}
                shadow="md"
                zIndex="dropdown"
            >
                <Box
                    data-testid="help-list-content"
                    display="flex"
                    alignItems="center"
                    flexDirection="column"
                >
                    <Button
                        colorScheme="primary"
                        variant="ghost"
                        w="100%"
                        onClick={() =>
                            window.open(
                                'https://registrauto-manuais.s3.sa-east-1.amazonaws.com/Termos_de_uso_e_privacidade_da_Plataforma_Registrauto_ERDOC.pdf',
                                '_blank'
                            )
                        }
                    >
                        Termos de Uso e Privacidade
                    </Button>

                    <Menu placement="right-start">
                        <MenuButton
                            as={Button}
                            colorScheme="primary"
                            variant="ghost"
                            w="100%"
                        >
                            Manuais
                        </MenuButton>
                        <MenuList
                            data-testid="help-list"
                            border={1}
                            shadow="md"
                            zIndex="dropdown"
                            width="200px"
                        >
                            <Button
                                colorScheme="primary"
                                variant="ghost"
                                w="100%"
                                justifyContent="center"
                                onClick={() =>
                                    window.open(
                                        'https://registrauto-manuais.s3.sa-east-1.amazonaws.com/Manual_de_Operacao_Plataforma_Registrauto_ERDOC.pdf',
                                        '_blank'
                                    )
                                }
                            >
                                Manual de Operação
                            </Button>
                            <Button
                                colorScheme="primary"
                                variant="ghost"
                                w="100%"
                                justifyContent="center"
                                onClick={() =>
                                    window.open(
                                        'https://registrauto-manuais.s3.sa-east-1.amazonaws.com/Registro_de_Contrato_de_Financiamento_de_Veiculos_-_Contrato_em_Lote_-_Leiautes.pdf',
                                        '_blank'
                                    )
                                }
                            >
                                Manual de Contrato em Lote
                            </Button>
                            <Button
                                colorScheme="primary"
                                variant="ghost"
                                w="100%"
                                justifyContent="center"
                                onClick={() =>
                                    window.open(
                                        'https://registrauto-manuais.s3.sa-east-1.amazonaws.com/Manual_de_Integracao_Sistema_Registrauto_ERDOC_V1.pdf',
                                        '_blank'
                                    )
                                }
                            >
                                Manual de Integração
                            </Button>
                            <Button
                                colorScheme="primary"
                                variant="ghost"
                                w="100%"
                                justifyContent="center"
                                onClick={() =>
                                    window.open(
                                        'https://registrauto-manuais.s3.sa-east-1.amazonaws.com/V%C3%ADdeo+Demonstrativo.mp4',
                                        '_blank'
                                    )
                                }
                            >
                                Vídeo Operacional
                            </Button>
                            <Button
                                colorScheme="primary"
                                variant="ghost"
                                w="100%"
                                justifyContent="center"
                                onClick={() =>
                                    window.open(
                                        'https://registrauto-manuais.s3.sa-east-1.amazonaws.com/FAQ_Registro_Financiamento_RegistraAuto_ERDOC.pdf',
                                        '_blank'
                                    )
                                }
                            >
                                FAQ
                            </Button>
                        </MenuList>
                    </Menu>

                    <Menu placement="right-start">
                        <MenuButton
                            as={Button}
                            colorScheme="primary"
                            variant="ghost"
                            w="100%"
                        >
                            Portarias
                        </MenuButton>
                        <MenuList
                            data-testid="help-list"
                            border={1}
                            shadow="md"
                            zIndex="dropdown"
                            width="200px"
                        >
                            <Button
                                colorScheme="primary"
                                variant="ghost"
                                w="100%"
                                justifyContent="center"
                                onClick={() =>
                                    window.open(
                                        'https://detran.es.gov.br/leis-e-decretos-estaduais',
                                        '_blank'
                                    )
                                }
                            >
                                Detran ES
                            </Button>                            
                            <Button
                                colorScheme="primary"
                                variant="ghost"
                                w="100%"
                                justifyContent="center"
                                onClick={() =>
                                    window.open(
                                        'https://transito.mg.gov.br/sobre/legislacao/consulta-de-portarias-da-cet-mg',
                                        '_blank'
                                    )
                                }
                            >
                                Detran MG
                            </Button>
                            <Button
                                colorScheme="primary"
                                variant="ghost"
                                w="100%"
                                justifyContent="center"
                                onClick={() =>
                                    window.open(
                                        'https://www.detran.mt.gov.br/portaria',
                                        '_blank'
                                    )
                                }
                            >
                                Detran MT
                            </Button>                                   
                            <Button
                                colorScheme="primary"
                                variant="ghost"
                                w="100%"
                                justifyContent="center"
                                onClick={() =>
                                    window.open(
                                        'https://www.detran.rj.gov.br/transparencia/legislacao/portarias',
                                        '_blank'
                                    )
                                }
                            >
                                Detran RJ
                            </Button>                  
                            <Button
                                colorScheme="primary"
                                variant="ghost"
                                w="100%"
                                justifyContent="center"
                                onClick={() =>
                                    window.open(
                                        'https://www.detran.sc.gov.br/portarias-ate-2025/',
                                        '_blank'
                                    )
                                }
                            >
                                Detran SC
                            </Button>          
                            <Button
                                colorScheme="primary"
                                variant="ghost"
                                w="100%"
                                justifyContent="center"
                                onClick={() =>
                                    window.open(
                                        'https://www.detran.sp.gov.br/detransp/en/regulacao/normas?id=portarias',
                                        '_blank'
                                    )
                                }
                            >
                                Detran SP
                            </Button>
                            <Button
                                colorScheme="primary"
                                variant="ghost"
                                w="100%"
                                justifyContent="center"
                                onClick={() =>
                                    window.open(
                                        'https://www.to.gov.br/detran/portarias/1diu6pfhdy9f',
                                        '_blank'
                                    )
                                }
                            >
                                Detran TO
                            </Button>
                        </MenuList>
                    </Menu>

                    <Box mt={8}>
                        <SystemVersion isOpen={true} />
                    </Box>
                </Box>
            </MenuList>
        </Menu>
    )
}
